































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import AreaPicker from '@/components/areapicker.vue';
import TsUpload from '@/components/upload.vue';

import Price from '../stadium/components/price.vue';

import Close from './close.vue';

@Component({
  components: {
    AreaPicker,
    TsUpload,
    Price,
    Close,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() showReportModal!: Function

  grounds: any[] = [];

  status: any = {
    business_license: false,
    principal_identity_card_person_pic: false,
    principal_identity_card_pic_contrary: false,
    principal_identity_card_pic_positive: false,
    attachment_code: false,
  };

  closeModalVisible = false;

  attachmentFileList: any[] = [];

  showReportModal1() {
    this.handleCancel();
    this.showReportModal();
  }

  handleAttachmentPreview(file: any) {
    this.showImage(file.url || file.thumbUrl);
  }

  handleAttachmentChange({ fileList }: any) {
    this.attachmentFileList = fileList;
  }

  confirmAttachmentRemove() {
    return new Promise((resolve, reject) => {
      this.$confirm({
        title: '确认信息',
        content: '确定要删除该图片吗？',
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  }

  showCloseModal() {
    this.closeModalVisible = true;
  }

  hideCloseModal() {
    this.closeModalVisible = false;
    this.handleCancel();
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            const res = await this.$store.dispatch('enterapply/audit', {
              stadium_id: this.editId,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              if (res.Data && String(res.Data) === '2') {
                // 审核通过
                // this.$warning({
                //   title: "操作提示",
                //   content: "请检查并下线相似的微信接单场馆",
                // });
                this.$message.success(res.Message);
                // 显示合作调研报告
                // this.$router.push(`/stadium/detail?id=${this.editId}&action=key18`);
                this.showReportModal1();
              } else {
                // 审核不通过
                this.$message.success(res.Message);
              }
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  async loadGrounds() {
    const res = await this.$store.dispatch('stadium/getStadiumGrounds', {
      stadium_id: this.editId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.grounds = res.Data;
    }
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch('enterapply/detail', {
      stadium_id: this.editId,
    });
    if (res && res.Data && String(res.Data) !== '{}') {
      this.loadGrounds();

      // if (res.Data.business_license) {
      //   const url = await this.getImageUrl(res.Data.business_license);
      //   res.Data.business_license_pic = url;
      // }

      // if (res.Data.principal_identity_card_pic_contrary) {
      //   const url1 = await this.getImageUrl(
      //     res.Data.principal_identity_card_pic_contrary
      //   );
      //   res.Data.principal_identity_card_pic_contrary = url1;
      // }

      // if (res.Data.principal_identity_card_pic_positive) {
      //   const url2 = await this.getImageUrl(
      //     res.Data.principal_identity_card_pic_positive
      //   );
      //   res.Data.principal_identity_card_pic_positive = url2;
      // }

      // if (res.Data.principal_identity_card_person_pic) {
      //   const url3 = await this.getImageUrl(
      //     res.Data.principal_identity_card_person_pic
      //   );
      //   res.Data.principal_identity_card_person_pic = url3;
      // }

      // if (res.Data.sign_video) {
      //   const url4 = await this.getSecretVideo(res.Data.sign_video);
      //   res.Data.sign_video = url4;
      // }

      if (res.Data.attachment_code) {
        const arr: string[] = res.Data.attachment_code.split(',');
        for (const k in arr) {
          if (arr[k]) {
            // eslint-disable-next-line no-await-in-loop
            const req = await this.getImageUrl(arr[k]);
            // console.log(req);
            this.attachmentFileList.push({
              uid: k,
              name: '',
              status: 'done',
              url: req,
            });
          }
        }
      }

      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
